/* Edits on the components array of a post, done as copies.
 *
 * A post being created still carries the components of its layout template, and
 * Apollo hands those out deep-frozen: finding the header component and writing
 * comp.key on it threw "Cannot assign to read only property 'key'" and took the
 * choose-layout screen down with it. */

// The first component whose key contains keyFragment gets the new key. Returns the
// original array untouched - same reference - when there is no such component, so
// the caller can tell that nothing changed.
const replaceComponentKey = (components, keyFragment, value) => {
  if (!Array.isArray(components)) return components;

  const index = components.findIndex(comp => comp && typeof comp.key === 'string' && comp.key.includes(keyFragment));
  if (index === -1) return components;

  const newComponents = [...components];
  newComponents[index] = { ...newComponents[index], key: value };

  return newComponents;
};

module.exports = { replaceComponentKey };
